import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { toast } from 'sonner';

export default function Inventario() {
  const [warehouses, setWarehouses] = useState([]);
  const [balances, setBalances] = useState([]);
  const [warehouseId, setWarehouseId] = useState('');
  const [groupCode, setGroupCode] = useState('');
  const [invType, setInvType] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => { API.get('/catalogs/warehouses').then(res => setWarehouses(res.data)); }, []);

  useEffect(() => {
    const params = {};
    if (warehouseId && warehouseId !== 'all') params.warehouse_id = warehouseId;
    if (groupCode && groupCode !== 'all') params.group_code = groupCode;
    if (invType && invType !== 'all') params.inventory_type = invType;
    setLoading(true);
    API.get('/inventario/balances', { params }).then(res => setBalances(res.data.balances || [])).catch(() => toast.error('Error')).finally(() => setLoading(false));
  }, [warehouseId, groupCode, invType]);

  const GROUPS = ['GP1', 'GP2', 'GP3', 'GP4', 'GP5', 'GP6', 'GP7'];
  const TYPES = ['usado_disponible', 'usado_en_revision', 'en_tarima'];
  const TYPE_LABELS = { usado_disponible: 'Disponible', usado_en_revision: 'En Revisión', en_tarima: 'En Tarima' };

  return (
    <div className="space-y-4">
      <div><h1 className="text-xl font-semibold">Consulta de Inventario</h1><p className="text-sm text-muted-foreground">Existencias de acumuladores usados por almacén, grupo y estado</p></div>
      <Card className="bg-white border"><CardContent className="p-4"><div className="flex flex-wrap gap-3">
        <Select value={warehouseId} onValueChange={setWarehouseId}>
          <SelectTrigger className="w-[200px]" data-testid="inventario-warehouse-filter"><SelectValue placeholder="Todos los almacenes" /></SelectTrigger>
          <SelectContent><SelectItem value="all">Todos</SelectItem>{warehouses.map(w => <SelectItem key={w.id} value={w.id}>{w.nombre}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={groupCode} onValueChange={setGroupCode}>
          <SelectTrigger className="w-[150px]"><SelectValue placeholder="Todos los grupos" /></SelectTrigger>
          <SelectContent><SelectItem value="all">Todos</SelectItem>{GROUPS.map(g => <SelectItem key={g} value={g}>{g}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={invType} onValueChange={setInvType}>
          <SelectTrigger className="w-[160px]"><SelectValue placeholder="Todos los estados" /></SelectTrigger>
          <SelectContent><SelectItem value="all">Todos</SelectItem>{TYPES.map(t => <SelectItem key={t} value={t}>{TYPE_LABELS[t]}</SelectItem>)}</SelectContent>
        </Select>
      </div></CardContent></Card>
      <Card className="bg-white border"><CardContent className="p-0">
        <Table><TableHeader><TableRow className="bg-muted/30">
          <TableHead>Almacén</TableHead><TableHead>Grupo</TableHead><TableHead>Estado</TableHead><TableHead className="text-right">Existencia</TableHead>
        </TableRow></TableHeader>
        <TableBody>
          {loading && <TableRow><TableCell colSpan={4} className="text-center py-8">Cargando...</TableCell></TableRow>}
          {!loading && balances.length === 0 && <TableRow><TableCell colSpan={4} className="text-center text-muted-foreground py-8">Sin resultados</TableCell></TableRow>}
          {!loading && balances.map((b, i) => (
            <TableRow key={i} className="hover:bg-muted/40">
              <TableCell>{b.warehouse_nombre || b.warehouse_id}</TableCell>
              <TableCell className="font-medium">{b.group_code}</TableCell>
              <TableCell>{TYPE_LABELS[b.inventory_type] || b.inventory_type}</TableCell>
              <TableCell className="text-right font-semibold text-lg">{b.existencia_actual}</TableCell>
            </TableRow>
          ))}
        </TableBody></Table>
      </CardContent></Card>
      {balances.length > 0 && (<Card className="bg-white border"><CardContent className="p-4">
        <p className="text-sm text-muted-foreground">Total de registros: <strong>{balances.length}</strong> | Total piezas: <strong>{balances.reduce((s, b) => s + b.existencia_actual, 0)}</strong></p>
      </CardContent></Card>)}
    </div>
  );
}
